/**
 * SE の読み込み（Issue #378）。ブラウザの Web Audio を使う。
 * 何をいつ鳴らすかはコアのきっかけ（`duelEditor/timeline/cues.js`）が決め、鳴らすのは `webAudio.js`。
 */

/** SE をデコードして Map(name → AudioBuffer) に足す。読めなかった名前は failed に。cache は呼ぶ側が持つ Map */
export async function loadSeBuffers({ ctx, names, urlOf, cache = new Map(), fetchImpl = (u) => fetch(u) }) {
  const failed = [];
  await Promise.all(names.map(async (name) => {
    if (cache.has(name)) return;
    const url = urlOf(name);
    if (!url) { failed.push(name); return; }
    try {
      const res = await fetchImpl(url);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const buf = await ctx.decodeAudioData(await res.arrayBuffer());
      cache.set(name, buf);
    } catch (e) {
      failed.push(name);
    }
  }));
  return { buffers: cache, failed };
}
